__turbopack_context__.v({
  "btn": "O4V6Oq_btn",
  "btnContent": "O4V6Oq_btnContent",
  "btnFooter": "O4V6Oq_btnFooter",
  "btnIcon": "O4V6Oq_btnIcon",
  "btnText": "O4V6Oq_btnText",
  "cards": "O4V6Oq_cards",
  "content": "O4V6Oq_content",
  "headContact": "O4V6Oq_headContact",
  "imgbabyAI": "O4V6Oq_imgbabyAI",
  "imgbabyText": "O4V6Oq_imgbabyText",
  "p": "O4V6Oq_p",
  "page-body-wrap": "O4V6Oq_page-body-wrap",
  "pagehero": "O4V6Oq_pagehero",
  "paragraph": "O4V6Oq_paragraph",
  "paragraph-content": "O4V6Oq_paragraph-content",
  "t": "O4V6Oq_t",
  "title": "O4V6Oq_title",
  "wrap-container": "O4V6Oq_wrap-container",
  "wrap-content": "O4V6Oq_wrap-content",
});
